import React, { useEffect, useMemo, useState } from 'react';
import Select from 'react-select';
import { useField, useFormikContext } from 'formik';
import client from 'utils/client';

// Typeahead picker backed by /merchants. Fetches once on mount (merchants list is
// small; swap to AsyncSelect + server-side search if the count grows past a few thousand).
const MerchantPicker = ({ name = 'merchantId', label = 'Merchant', required }) => {
  const [field] = useField(name);
  const { setFieldValue } = useFormikContext();
  const [merchants, setMerchants] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    client
      .get('/merchants?page=1&pageSize=1000')
      .then((res) => setMerchants(res.data?.data || []))
      .catch(() => setError('Could not load merchants'))
      .finally(() => setLoading(false));
  }, []);

  const options = useMemo(() => merchants.map((m) => ({
    value: m.id,
    label: `${m.first_name || ''} ${m.last_name || ''}`.trim() || `Merchant #${m.id}`,
    sub: m.account_number || m.email || '',
  })), [merchants]);

  const selected = options.find((o) => String(o.value) === String(field.value)) || null;

  return (
    <div className='add-terminal-item'>
      <label>{label}{required && <span style={{ color: 'var(--color-danger)' }}> *</span>}</label>
      <Select
        inputId={`select-${name}`}
        options={options}
        value={selected}
        onChange={(opt) => setFieldValue(name, opt?.value ?? '')}
        isLoading={loading}
        isClearable
        placeholder='Search by name or account number…'
        noOptionsMessage={() => (error || 'No merchants found')}
        formatOptionLabel={(opt) => (
          <div style={{ lineHeight: 1.25 }}>
            <div style={{ fontWeight: 500 }}>{opt.label}</div>
            {opt.sub && (
              <div style={{ fontSize: 12, color: 'var(--color-text-muted)' }}>{opt.sub}</div>
            )}
          </div>
        )}
      />
    </div>
  );
};

export default MerchantPicker;
